import { divWithClassName } from '../../../services/Component';

import styles from './style.m.less';

export const Mask = divWithClassName(styles.mask);
export const Gradient = divWithClassName(styles.gradient);
export const GradientContainer = divWithClassName(styles.gradientContainer);
